import { useRouter } from "next/router";
import { Dialog } from "@blueprintjs/core";
import { isValidLoginCallbackUrl } from "../../src/consts/urls";
import HomepageAccountFormContainer from "../../components/login/accountformcontainer";
import Title from "@/components/global/title";

export default function LoginPage() {
    const router = useRouter();
    const errorCode = router.query.error as string ?? '';
    let callbackUrl = router.query.callbackUrl as string ?? '/';
    if (!isValidLoginCallbackUrl(callbackUrl)) {
        callbackUrl = '/';
    }

    let error: string;
    switch (errorCode) {
        case '':
            break;
        default:
        case 'OAuthSignin':
        case 'OAuthCallback':
        case 'OAuthCreateAccount':
        case 'EmailCreateAccount':
        case 'Callback':
        case 'OAuthAccountNotLinked':
        case 'EmailSignin':
        case 'SessionRequired':
            error = `Something weird happened that should not have: '${errorCode}'`;
            break;
        case 'Default':
            error = 'An unknown error happened';
            break;
        case 'CredentialsSignin':
            error = 'Please double check your email address and password, something was not right';
            break;
    }

    const onClose = () => {
        router.push('/');
    }
    return <>
        <Title subtitle="Login" />
        <Dialog isOpen={true} onClose={onClose}>
            <HomepageAccountFormContainer error={error} successPath={callbackUrl} />
        </Dialog>
    </>;
};
